'use client'

import Padder from 'src/components/_layout/Padder/Padder'
import RichText from 'src/components/atoms/RichText/RichText'
import Text from 'src/components/atoms/Text/Text'
import * as Styles from './DoubleColumn.style'

type DoubleColumnProps = {
    title?: string
    noMargin?: boolean
    columns: {
        content: {
            title?: string
            description: string
        }[]
    }[]
}

export default function DoubleColumn(props: DoubleColumnProps) {
    const { columns, title, noMargin } = props
    return (
        <Styles.Wrapper>
            {title && <RichText htmlString={title} textVariant="titleMedium" />}

            <Styles.ColumnsWrapper noMargin={noMargin}>
                {columns.map(({ content }, index) => (
                    <Styles.Column key={index}>
                        <Padder top="lg">
                            {content.map(({ title, description }, j) => (
                                <Padder top="xs" key={j}>
                                    <Text as={Text} textVariant="titleSmall">
                                        {title}
                                    </Text>
                                    <RichText
                                        htmlString={description}
                                        textVariant={
                                            noMargin ? 'base' : 'smallItalic'
                                        }
                                    />
                                </Padder>
                            ))}
                        </Padder>
                    </Styles.Column>
                ))}
            </Styles.ColumnsWrapper>
        </Styles.Wrapper>
    )
}
